
import FormControl from "../../../MUI_components/FormControl/fomikFormControl";
import { Form, Formik } from "formik";
import React,{useRef} from "react";
import reportsService from "../../../../Service/Reports/reports.service";
import ReactToPrint from "react-to-print";
import { pageStyle } from "../../../Print/printPagesStyles";
import BasicTable from "../../../MUI_components/Table/basicTable";
import ReportPrintTable from "../../reportPrintTable";
import { Button, Paper } from "@mui/material";
import { useDispatch } from "react-redux";
import { openSnackbar } from "../../../../Redux/Actions/snackbarActions";
import * as yup from "yup";
// import Reports from "Components/Print/a4-report-print";

import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { attempt } from "lodash";
import { currency } from "Components/MUI_components/currencyFormatterTag";
import Reports from "../../../../Components/Reports/reports";

export default function Dailyresults() {
  const dispatch = useDispatch();
  var date = new Date();
  var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    .toISOString()
    .split("T")[0];
  const today = date.toISOString().split("T")[0];

  const [results, setResults] = React.useState({
    rows: [],
    date: null,
    loading: false,
  });
  const tableRef = useRef(null);

  const HeadCells = [

    {
      key: (val) => {
        return  val["supplierModeOfPayment"]["paymentVoucher"]["supplier"]["name"];
      },
      align: "left",
      label: COLUMNS_NAME.SUPPLIER,
    },
  
    {
      key: (val) => {
        return val["code"]; 
      },
      align: "left",
      label: "Voucher " + COLUMNS_NAME.CODE,
    },
    {
      key: (val) => {
        return  val["depositDate"];
      },
      align: "left",
      label: COLUMNS_NAME.DEPOSIT_DATE,
    },
     {
      key: (val) => {
        return  val["number"];
      },
      align: "left",
      label: COLUMNS_NAME.NUMBER,
    },
    // {
    //   key: (val) => {
    //     return  val["supplierModeOfPayment"]["paymentVoucher"]["supplier"]["grns"].map((row)=>row.totalAmount);
    //   },
    //   align: "left",
    //   label: COLUMNS_NAME.TOTAL,
    // },
    {
      key: (val) => {
        return  val["amount"];
      },
      align: "right",
      label: COLUMNS_NAME.AMOUNT,
    },
    // {
    //   key: (val) => {
    //     return  val["supplierModeOfPayment"]["paymentVoucher"]["supplier"]["debitAmount"];
    //   },
    //   align: "left",
    //   label: COLUMNS_NAME.OUTSTANDING,
    // }

  ];
  const componentRef = React.useRef();

  const handleSubmit = async (values) => {
    setResults({
      ...results,
      loading: true,
    });
    try {
      const res = await reportsService.VovucherChequesInHand(
        values.fromDate,
        values.toDate
      );
      setResults({
        loading: false,
        rows: res.voucherChequeInHand,
        date: values.date,
      });
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
  };

  const billTotal = results.rows
  .map((props) => parseFloat(props["amount"]))
  .reduce((sum, i) => sum + i, 0);

 


  return (
    <div style={{ display: 'flex', width: '100%' }}>
    <div >
      <Reports />
    </div>
    <div style={{width: '100%'}}>
     <Formik
        initialValues={{
          fromDate: firstDay,
          toDate: today,
        }}
     
        onSubmit={handleSubmit}
      >
        {() => {
          return (
            <Form>
              <div className="flex mt mb">
                <div className="col-4">
                  <FormControl
                    control="input"
                    type="date"
                    name="fromDate"
                    size="small"
                    label="From"
                    inputProps={{
                      max: today,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </div>
                <div className="col-4">
                  <FormControl
                    control="input"
                    type="date"
                    name="toDate"
                    size="small"
                    label="To"
                    inputProps={{
                      max: today,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </div>
                <div className="col-6">
                  <Button variant="contained" type="submit" color="primary">
                    Find
                  </Button>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
      <Paper>
        <div className="flex-end">
          <ReactToPrint
            trigger={() => (
              <Button
                style={{ margin: 5 }}
                disabled={!results.rows.length}
                variant="contained"
              >
                Print
              </Button>
            )}
            content={() => componentRef.current}
            pageStyle={pageStyle.a4}
          />
           <DownloadTableExcel
            filename="daily Payment Receipt"
            currentTableRef={tableRef.current}
          >
            <Button
              style={{ margin: 5 }}
              disabled={!results.rows.length}
              variant="contained"
            >
              Export to Excel </Button>
          </DownloadTableExcel>
        </div>
        <div style={{ display: "none" }}>
            <Reports title={`Periodic Payment Voucher: ${results.date}`}>
            <div ref={componentRef}>
              <ReportPrintTable
                headCells={HeadCells}
                rows={results.rows}
                // lastRow="Total"
                // billTotal={billTotal}
              >
             <tr>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th>Total</th>
              <th align="right">{currency(billTotal)}</th>
             </tr>
               
              </ReportPrintTable>
              </div>
            </Reports>
        </div>

        <BasicTable
          headCells={HeadCells}
          rows={results.rows}
          isLoaded={results.loading}
          tableRef={tableRef}

        />
      </Paper>
    </div>
    </div>
  );
}
